/* Mattress Central brand PDP behaviour: sticky add-to-cart + section menu, layer tabs, FAQ filter. No dependencies. */
(function () {
  'use strict';
  document.documentElement.classList.add('mc-js');

  function initSticky() {
    var bars = document.querySelectorAll('[data-mc-sticky]');
    var bar = bars[bars.length - 1];
    if (!bar) return;
    var main = document.getElementById(bar.getAttribute('data-main'));
    if (!main) return;
    // Move to <body> so a transformed theme wrapper can't break position: fixed.
    Array.prototype.forEach.call(bars, function (b) { if (b !== bar) b.remove(); });
    if (bar.parentNode !== document.body) document.body.appendChild(bar);
    bar.removeAttribute('hidden');
    bar.setAttribute('aria-hidden', 'true');
    bar.inert = true;
    var form = main.querySelector('.product-form__submit') || main;
    var btn = bar.querySelector('[data-mc-sticky-btn]');
    var priceEl = bar.querySelector('[data-mc-sticky-price]');

    function syncPrice() {
      if (!priceEl) return;
      var p = main.querySelector('.price');
      if (!p) return;
      var el = p.classList.contains('price--on-sale') ? p.querySelector('.price__sale .price-item--last') : p.querySelector('.price__regular .price-item--regular');
      if (el && el.textContent.trim()) priceEl.textContent = el.textContent.trim();
    }
    function show(v) {
      bar.classList.toggle('is-visible', v);
      bar.setAttribute('aria-hidden', v ? 'false' : 'true');
      bar.inert = !v;
      if (v) syncPrice();
    }
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var e = entries[0];
        show(!e.isIntersecting && e.boundingClientRect.top < 0);
      }).observe(form);
    }
    if (btn) {
      btn.addEventListener('click', function () {
        var submit = main.querySelector('.product-form__submit');
        if (submit && !submit.disabled && !btn.hasAttribute('data-soldout')) {
          submit.click();
        } else {
          main.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    }

    var list = bar.querySelector('[data-mc-nav-list]');
    if (!list) return;
    var targets = Array.prototype.slice.call(document.querySelectorAll('[data-mc-nav]'));
    if (!targets.length) { list.closest('nav').remove(); return; }
    var links = [];
    targets.forEach(function (t) {
      var li = document.createElement('li');
      var a = document.createElement('a');
      a.href = '#' + t.id;
      a.textContent = t.getAttribute('data-mc-nav');
      li.appendChild(a); list.appendChild(li); links.push(a);
    });
    // Highlight the section the reader is in: the target spanning a line just below the sticky
    // bar (bar height + 30% of the viewport). None before, between or after navigated sections.
    var current = null;
    function setCurrent(id) {
      if (id === current) return;
      current = id;
      links.forEach(function (a) { a.setAttribute('aria-current', id && a.getAttribute('href') === '#' + id ? 'true' : 'false'); });
      if (id) {
        var on = list.querySelector('a[aria-current=true]');
        if (on && list.scrollWidth > list.clientWidth) {
          var l = on.getBoundingClientRect().left - list.getBoundingClientRect().left + list.scrollLeft;
          if (l < list.scrollLeft || l + on.offsetWidth > list.scrollLeft + list.clientWidth) list.scrollLeft = l - 16;
        }
      }
    }
    var ticking = false;
    function update() {
      ticking = false;
      var line = (bar.classList.contains('is-visible') ? bar.offsetHeight : 0) + window.innerHeight * 0.3;
      var id = null;
      for (var i = 0; i < targets.length; i++) {
        var r = targets[i].getBoundingClientRect();
        if (r.height === 0) continue;
        if (r.top > line) break;
        // Only the section that spans the line counts; un-navigated sections in between clear it.
        id = r.bottom > line ? targets[i].id : null;
      }
      setCurrent(id);
    }
    function onScroll() { if (!ticking) { ticking = true; window.requestAnimationFrame(update); } }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    update();
  }

  function initTabs(root) {
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[role=tab]'));
    function select(tab, focus) {
      tabs.forEach(function (t) {
        var on = t === tab;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        var panel = document.getElementById(t.getAttribute('aria-controls'));
        if (panel) panel.hidden = !on;
      });
      if (focus) tab.focus();
    }
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { select(t); });
      t.addEventListener('keydown', function (e) {
        var n = null;
        if (e.key === 'ArrowRight') n = tabs[(i + 1) % tabs.length];
        if (e.key === 'ArrowLeft') n = tabs[(i - 1 + tabs.length) % tabs.length];
        if (e.key === 'Home') n = tabs[0];
        if (e.key === 'End') n = tabs[tabs.length - 1];
        if (n) { e.preventDefault(); select(n, true); }
      });
    });
  }

  function initFaq(root) {
    var chips = Array.prototype.slice.call(root.querySelectorAll('[data-filter]'));
    var items = Array.prototype.slice.call(root.querySelectorAll('[data-cat]'));
    chips.forEach(function (c) {
      c.addEventListener('click', function () {
        var f = c.getAttribute('data-filter');
        chips.forEach(function (x) { x.setAttribute('aria-pressed', x === c ? 'true' : 'false'); });
        items.forEach(function (it) { it.hidden = !(f === '*' || it.getAttribute('data-cat') === f); });
      });
    });
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-mc-tabs]').forEach(initTabs);
    (scope || document).querySelectorAll('[data-mc-faq]').forEach(initFaq);
  }
  // Some product titles use no-break spaces (U+202F/U+00A0), which forces mid-word breaks
  // on narrow screens. Swap them for normal spaces in the visible title only.
  function fixTitleSpaces() {
    document.querySelectorAll('.product__title h1, .product__title h2, .mc-sticky__title').forEach(function (el) {
      var w = document.createTreeWalker(el, NodeFilter.SHOW_TEXT), n;
      while ((n = w.nextNode())) { if (/[\u00A0\u202F]/.test(n.nodeValue)) n.nodeValue = n.nodeValue.replace(/[\u00A0\u202F]/g, ' '); }
    });
  }
  function boot() { fixTitleSpaces(); initSticky(); init(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); if (e.target.querySelector('[data-mc-sticky]')) initSticky(); });
})();
